import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserPreSharedKey } from 'app/shared/models/user-presharedkey.model';
import { UserService } from 'app/shared/services/user.service';
import { Utils } from 'app/shared/utils/utils';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-presharedkey',
  templateUrl: './user-presharedkey.component.html',
  styleUrls: ['./user-presharedkey.component.scss']
})
export class UserPreSharedKeyComponent implements OnInit {

  @Input() currentObjectId: number;
  @Output() afterSubmitEvent = new EventEmitter<object>();

  currentObject: UserPreSharedKey;

  get hasInvalidPreSharedKey(): boolean {
    return Utils.isStringNullOrWhiteSpace(this.currentObject.PreSharedKey);
  }

  constructor(protected userService: UserService, protected toastrService: ToastrService, public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    this.currentObject = new UserPreSharedKey();
    this.userService.getObject<UserPreSharedKey>('/users/' + this.currentObjectId + '/presharedkey', null, (userPresharedKey) => {
      this.currentObject = userPresharedKey
    });

  }

  copyPresharedKey(value: string) {
    Utils.copyToClipBoard(this.toastrService, "Pre Shared Key copied to the clipboard", value);
  }

  closeModal() {
    this.activeModal.close();
    this.afterSubmitEvent.emit();
  }
}
